import React, { useEffect } from 'react';
import {
  Box,
  Grid,
  FormControl,
  FormLabel,
  FormHelperText,
  Avatar,
} from '@mui/material';
import { Controller } from 'react-hook-form';

type Props = {
  label: string;
  id: string;
  name: string;
  className?: string;
  variant?: 'standard' | 'filled' | 'outlined';
  disabled?: boolean;
  maxFileSizeMB?: number;
  multiple?: boolean;
  image?: boolean;
  onChange?: (files: File[] | null) => void;
  acceptFileTypes?: string;
  control: any;
  rules?: any;
  align?: 'Normal' | 'Start';
  imgUrl?: string;
  isToolTipImg?: boolean;
};

const WSImageUpload: React.FC<Props> = ({
  label,
  id,
  name,
  className,
  disabled = false,
  maxFileSizeMB = 2,
  multiple = false,
  image = false,
  onChange,
  acceptFileTypes = 'image/*',
  control,
  rules,
  align = 'Normal',
  imgUrl,
}) => {
  const [previewUrl, setPreviewUrl] = React.useState<string | undefined>(imgUrl);

  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    field: any
  ) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const validFiles = Array.from(files).filter((file) => {
      if (file.size / 1024 / 1024 > maxFileSizeMB) {
        alert(`File ${file.name} exceeds ${maxFileSizeMB}MB`);
        return false;
      }
      return true;
    });

    const file = validFiles[0];
    if (file) {
      const preview = URL.createObjectURL(file);
      setPreviewUrl(preview);
    }

    field.onChange(multiple ? validFiles : file);
    onChange?.(multiple ? validFiles : [file]);
  };

  React.useEffect(() => {
    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);
useEffect(()=>{
    if(imgUrl){
        setPreviewUrl(imgUrl)
    }

},[imgUrl])
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <FormControl
          className={className}
          fullWidth
          error={!!fieldState.error}
          disabled={disabled}
        >
          <FormLabel sx={{ fontSize: '0.875rem', color: 'black', mb: 1 }}>
            {label}
          </FormLabel>

          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Box
                component="label"
                htmlFor={id}
                sx={{
                  position: 'relative',
                  width: 80,
                  height: 80,
                  cursor: disabled ? 'not-allowed' : 'pointer',
                  '&:hover .overlay': {
                    opacity: 1,
                  },
                }}
              >
                <Avatar
                  src={previewUrl}
                  alt="preview"
                  sx={{ width: 80, height: 80 }}
                />

                <Box
                  className="overlay"
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    bgcolor: 'rgba(0, 0, 0, 0.5)',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    opacity: 0,
                    transition: 'opacity 0.3s',
                    fontSize: '0.75rem',
                    textAlign: 'center',
                    px: 1,
                  }}
                >
                  Click to change the image
                </Box>
              </Box>

              <input
                id={id}
                type="file"
                accept={acceptFileTypes}
                style={{ display: 'none' }}
                multiple={multiple}
                disabled={disabled}
                onChange={(event) => handleFileChange(event, field)}
              />
            </Grid>
          </Grid>

          {fieldState.error && (
            <FormHelperText>{fieldState.error.message}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};

export default WSImageUpload;
